//import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/contract/QueryPage'
export const batchUpdateOrDelete = '/icps/system/sign/dataCollection/contract/deletes' //启用禁用
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/dataCollection/contractBase/saveOrUpdate'
export const Download = '/icps/system/sign/dataCollection/contract/exportList'
import request from '@/utils/request'
export function QueryPageByMaterials(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/QueryPageByMaterials',
    method: 'get',
    params
  })
}
export function engineeringManagementQueryPage(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/QueryPage',
    method: 'post',
    data
  })
}
export function processes_collection(data) { //返回多个站点的业务点勾选合集-杜春林写3/25号
  return request({
    url: '/icps/system/sign/basics/technological/processes_collection',
    method: 'post',
    data
  })
}
export function contractSaveOrUpdate(data) { //根据站点获取管控业务点数据
  return request({
    url: '/icps/system/sign/dataCollection/contract/saveOrUpdate',
    method: 'post',
    data
  })
}
export function contractQueryDetailById(data) { //获取合同详情
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryDetailById',
    method: 'post',
    data
  })
}
export function riseInPriceQueryOneByid(data) { //查询调价列表
  return request({
    url: '/icps/system/sign/dataCollection/contractProduct/getListByPid',
    method: 'post',
    data
  })
}
export function QueryOneByid(data) { //查询调价详情
  return request({
    url: '/icps/system/sign/dataCollection/contractRawMoney/QueryPage',
    method: 'post',
    data
  })
}
export function contractRawMoneySave(data) { //原物料合同管理-新增原物料调价
  return request({
    url: '/icps/system/sign/dataCollection/contractRawMoney/save',
    method: 'post',
    data
  })
}
export function contractRawMoneyDeletes(data) { //原物料合同管理-删除调价
  return request({
    url: '/icps/system/sign/dataCollection/contractRawMoney/deletes',
    method: 'post',
    data
  })
}
export function contractAccountGetDetail(data) { //开户信息详情
  return request({
    url: '/icps/system/sign/dataCollection/contractAccount/getDetail',
    method: 'post',
    data
  })
}
export function contractAccountSave(data) { //保存开户信息
  return request({
    url: '/icps/system/sign/dataCollection/contractAccount/save',
    method: 'post',
    data
  })
}
export function queryUserIsUse(data) {
  //
  return request({
    url: "/icps/system/sign/dataCollection/contract/queryUserIsUse",
    method: "post",
    data,
  });
}
export function getLandedPrice(data) {
  //
  return request({
    url: "/icps/system/sign/dataCollection/contract/getLandedPrice",
    method: "post",
    data,
  });
}
export function queryPageBycontractids(data) {//查询原物料
  return request({
    url: "/icps/system/sign/basics/rawMaterials/queryPageBycontractids",
    method: "post",
    data,
  });
}
export function queryContractNumber(data) { //判断合同唯一性
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryContractNumber',
    method: 'post',
    data
  })
}
export function cooperationqueryListsByPid(data) { //获取协作单位
  return request({
    url: '/icps/system/sign/dataCollection/cooperation/queryListsByPid',
    method: 'post',
    data
  })
}
export function contractQueryPageContractLog(data) { //获取合同修改记录
  return request({
    url: '/icps/system/sign/dataCollection/contract/QueryPageContractLog',
    method: 'post',
    data
  })
}
export function contractUser(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contractUser/saveOrUpdate',
    method: 'post',
    data
  })
}
export function getListByContractId(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contractUser/getListByContractId',
    method: 'post',
    data
  })
}
export function get_simple_user_listBycompanyId(params) {
  return request({
    url: '/base/system/user/get_simple_user_listBycompanyId',
    method: 'get',
    params
  })
}
// 上面接口更新
export function getUserByOther(params) {
  return request({
    url: '/base/system/user/getUserByOther',
    method: 'get',
    params
  })
}
export function supplierQueryOneByid(data) {
  return request({
    url: '/icps/system/sign/dataCollection/supplier/QueryOneByid',
    method: 'post',
    data
  })
}
/**根据用户id和类型获取为用户授权的功能 */
export function clientGet_function(data) {
  return request({
    url: '/base/system/app/client/get_function',
    method: 'post',
    data
  })
}
/**工艺流程权限检测 */
export function judeJurisdiction(data) {
  return request({
    url: '/icps/system/sign/basics/technological/jurisdiction_contract',
    method: 'post',
    data
  })
}
